/* eslint-disable import/prefer-default-export */

// dependencies
import { GenerateProcess } from "redux-process";

// selectors
import { getCompanyID } from "../../selectors";

export const sendCompanySettingUpdate = (key, value) => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);

	// request
	dispatch(GenerateProcess("UpdateCompanySetting", { companyID, payload: { key, value } }));
};
